import axios from "axios";
import config from "@/router/globalConfig";

export default {
  getTransRequest(_data_, isTourOperator) {
    if (isTourOperator) {
      return axios.get(config.WEB_API_PATH + "PaymentPortal/TransRequest", {
        headers: {
          __RequestVerificationToken: config.AF_Token,
          Authorization: config.LOG_Token
        },
        params: _data_
      });
    } else {
      return axios.get(config.WEB_API_PATH + "PaymentGateway/TransRequest", {
        headers: {
          __RequestVerificationToken: config.AF_Token,
          Authorization: config.LOG_Token
        },
        params: _data_
      });
    }
  },
  getTransSuccess(_data_, isTourOperatorPayment) {
    if (isTourOperatorPayment) {
      return axios.get(config.WEB_API_PATH + "PaymentPortal/TransSuccess", {
        headers: {
          __RequestVerificationToken: config.AF_Token,
          Authorization: config.LOG_Token
        },
        params: _data_
      });
    } else {
      return axios.get(config.WEB_API_PATH + "PaymentGateway/TransSuccess", {
        headers: {
          __RequestVerificationToken: config.AF_Token,
          Authorization: config.LOG_Token
        },
        params: _data_
      });
    }
  },
  getTransStatus(_data_, isTourOperator) {
    if (isTourOperator) {
      return axios.get(config.WEB_API_PATH + "PaymentPortal/TransStatus", {
        headers: {
          __RequestVerificationToken: config.AF_Token,
          Authorization: config.LOG_Token
        },
        params: _data_
      });
    } else {
      return axios.get(config.WEB_API_PATH + "PaymentGateway/TransStatus", {
        headers: {
          __RequestVerificationToken: config.AF_Token,
          Authorization: config.LOG_Token
        },
        params: _data_
      });
    }
  },
  getTransRequestAPI(_data_) {
    return axios.post(
      "https://pilot.surepay.ndml.in/SurePayPayment/sp/processRequest",
      _data_,
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "Access-Control-Allow-Origin": "*"
          // headers: {
          //      "Content-Type": "application/x-www-form-urlencoded",
          //      "Access-Control-Allow-Origin": "*"
          // }
        },
        params: ""
      }
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/servicesJS/Transaction.js